
import request from '@/service/request'

export const getWxUserPage = (params: COMMON.API.QueryParams) => {
  return request<SERVICE.ResponsePage<WX.USER.DETAIL>>({
    url: '/admin/wxUser/page',
    method: 'GET',
    params
  })
}

export const getWxUserById = (id: string) => {
  return request<SERVICE.Response<WX.USER.DETAIL>>({
    url: '/admin/wxUser/' + id,
    method: 'GET'
  })
}

export const exportWxUser = () => {
  return request<Blob>({
    url: '/admin/exportExcel/wxUser',
    method: 'GET',
    responseType: 'blob'
  })
}

export const unbindDistribution = (userId: string) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/wxUser/agent/${userId}`,
    method: 'DELETE'
  })
}
